<i18n
  src="@/locales/views/customer/quality_reports/container_provider/show_process.yml"
  lang="yaml"
></i18n>
<i18n src="@/locales/models/container.yml" lang="yaml"></i18n>

<template>
  <go-back-link
    :text="$t('labels.go_back_link')"
    :name="routeName('')"
    :params="{
      customer_id: customer_id,
    }"
  ></go-back-link>

  <bread-crumbs
    :labels="[module_name, agro_exporter_process.name]"
  ></bread-crumbs>

  <template v-if="load_data_general">
    <tabs-container v-model="option_tabs" :with_routing="true" />

    <router-view
      :customer_id="customer_id"
      :agro_exporter_process_id="agro_exporter_process_id"
      :rejected_series="rejected_series"
      :weeks="weeks"
      :providers="providers"
      :defect_series="defect_series"
      :defects="defects"
    ></router-view>
  </template>
  <loading-message v-else />
</template>

<script>
import Requester from "@/views/customer/requesters/quality_reports/container_provider/show_process.js";

export default {
  name: "CusQualityReportsContainerProviderShowProcess",
  props: ["customer_id", "agro_exporter_process_id"],
  data() {
    return {
      load_data_general: false,
      agro_exporter_process: {},
      rejected_series: [],
      defect_series: [],
      defects: [],
      weeks: [],
      providers: [{id: null, name: "Todos"}],
      option_tabs: [],
    };
  },
  methods: {
    fetchAgroExporterProcess: async function () {
      let response = await Requester.fetchAgroExporterProcess(
        this.customer_id,
        this.agro_exporter_process_id
      );
      this.agro_exporter_process = response.data;
      this.providers.push(...response.data.agro_exporter_providers);
    },

    fetchRejectedPercentage: async function () {
      let response = await Requester.fetchRejectedPercentage(
        this.customer_id,
        this.agro_exporter_process_id
      );
      this.rejected_series = response.data.provider_series;
      this.weeks = response.data.weeks;

      this.load_data_general = true;
    },

    fetchTopDefects: async function (provider_id = null) {
      let response = await Requester.fetchTopDefects(
        this.customer_id,
        this.agro_exporter_process_id,
        provider_id
      );
      this.defects = response.data.defects;
      this.defect_series = response.data.provider_series;
    },

    fillOptions: function() {
      this.option_tabs = [
        {
          name: this.$t('labels.tabs.summary'),
          icon: "fa-solid fa-chart-pie",
          route: { name: this.routeName("show_process_summary") },
        },
        {
          name: this.$t('labels.tabs.weekly'),
          icon: "fa-solid fa-chart-line",
          route: { name: this.routeName("show_process_weekly") },
        },
        {
          name: this.$t('labels.tabs.quarterly'),
          icon: "fa-solid fa-calendar-alt",
          route: { name: this.routeName("show_process_quarterly") },
        },
      ]
    },
  },
  created() {
    this.checkIfAuthenticated().then(() =>
      this.checkIfAuthorized({
        role: this.$route.meta.role,
        permission: this.$route.meta.permission,
        entity: {
          customer_id: this.customer_id,
        },
      }).then(() => {
        this.fillOptions();
        this.fetchAgroExporterProcess();
        this.fetchRejectedPercentage();
        this.fetchTopDefects();
      })
    );
  },
};
</script>
